// extracted by mini-css-extract-plugin
export default {"text":"TextCopyForTooltip_text__SM8TF","icon":"TextCopyForTooltip_icon__HKib2"};